module.exports = __webpack_public_path__ + "static/diagram-e6325f0991c8df8fab2f21f0cce0ec3d.png";